import { render, staticRenderFns } from "./WebDownload.vue?vue&type=template&id=5dad8442&scoped=true"
import script from "./WebDownload.vue?vue&type=script&lang=js"
export * from "./WebDownload.vue?vue&type=script&lang=js"
import style0 from "./WebDownload.vue?vue&type=style&index=0&id=5dad8442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dad8442",
  null
  
)

export default component.exports